import { z } from "zod";
import { Organization } from "../organization.js";

export const CreateUpdateOrganizationInput = z.object({
    name: z.string(),
    description: z.string().optional().nullish(),
});

export const OrganizationSummary = z.object({
    id: z.number(),
    name: z.string(),
});

export const schema = {
    list: {
        input: z.object({
            search: z.string().min(0).max(100).optional(),
            page: z.number().min(0).optional(),
            pageSize: z.number().min(1).max(200).optional(),
            sortBy: z.enum(["name"]).optional(),
            sort: z.enum(["asc", "desc"]).optional(),
        }),
        output: z.object({
            organizations: z.array(Organization),
            totalFound: z.number(),
            total: z.number(),
        }),
    },
    listAll: {
        input: z.void(),
        output: z.array(OrganizationSummary),
    },
    get: {
        input: z.object({
            id: z.number(),
        }),
        output: Organization,
    },
    create: {
        input: z.object({
            organization: CreateUpdateOrganizationInput,
        }),
        output: Organization,
    },
    update: {
        input: z.object({
            id: z.number(),
            organization: CreateUpdateOrganizationInput,
        }),
        output: Organization,
    },
};
